import { render } from "./A1Form.vue?vue&type=template&id=2a30b92b&scoped=true"
import script from "./A1Form.vue?vue&type=script&lang=js"
export * from "./A1Form.vue?vue&type=script&lang=js"

import "./A1Form.vue?vue&type=style&index=0&id=2a30b92b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a30b92b"]])

export default __exports__